import React, { useState } from 'react';
import '../App.css';

function LeftPanel() {
    return(
        <div className='leftPanel'>

        </div>
    );
}

export default LeftPanel;